import { ActionTree } from 'vuex';
import {
  EDeleteDirectoryAction,
  EDeleteDirectoryMutation,
  state as defaultState,
} from '@/content-library/directories/delete/store/delete-directory.constants';
import { IDeleteDirectoryState } from '@/content-library/directories/delete/store/delete-directory.types';
import { RootState } from '@/store/store';
import { DirectoryService } from '@/api/directories/services/directory.service';
import { translate } from '@/helpers/translation.helper';
import { alertNamespace, EAlertAction } from '@/alert/store/alert.constants';

export const actions: ActionTree<IDeleteDirectoryState, RootState> = {
  async [EDeleteDirectoryAction.Delete]({ dispatch, commit }, id: string) {
    commit(EDeleteDirectoryMutation.SetDeleted, false);
    commit(EDeleteDirectoryMutation.SetDeleting, true);
    try {
      await DirectoryService.delete(id);
      dispatch(EDeleteDirectoryAction.DeleteSuccess);
    } catch (e) {
      dispatch(EDeleteDirectoryAction.DeleteFailed);
    }
  },
  [EDeleteDirectoryAction.DeleteSuccess]({ commit }) {
    commit(EDeleteDirectoryMutation.SetDeleting, false);
    commit(EDeleteDirectoryMutation.SetDeleted, true);
  },
  [EDeleteDirectoryAction.DeleteFailed]({ dispatch, commit }) {
    commit(EDeleteDirectoryMutation.SetDeleting, false);
    commit(EDeleteDirectoryMutation.SetDeleted, false);
    dispatch(`${alertNamespace}/${EAlertAction.ShowDanger}`, translate('could-not-delete-folder'), {
      root: true,
    });
  },
  [EDeleteDirectoryAction.Reset]({ commit }) {
    commit(EDeleteDirectoryMutation.SetState, { ...defaultState });
  },
};
